// extracted by mini-css-extract-plugin
export default {"form":"form_form__Czxwa","form__title":"form_form__title__WdB5b","form__box":"form_form__box__PKLyn"};